export default {
  setSession(state, n) {
    state.key = n.key
    state.userid = n.userid
    state.admin = n.admin ? true : false
    state.user_type = n.user_type
  },
  rmKey(state) {
    state.key = ''
    state.userid = ''
    state.admin = false
    state.user_type = 0
  },
  setMyConsumers(state, n) {
    state.consumers = n
  },
  setProduct(state, n) {
    state.shop_product = n
  },
  stopBanner(state) {
    state.seebanner = false
  },
  setShopOndemand(state, n) {
    state.shop_ondemand = n
  }
}
